import { selectSysDic } from "@/api/common";

// const cache = {};

// 根据键值获取字典数据
// async function getDicByName(name, isSingle = false, id) {
//   if (cache[name]) {
//     if (isSingle) {
//       const singleDicName = cache[name].find((item) => item.id == id);
//       return singleDicName;
//     }
//     return cache[name];
//   }
//   try {
//     const res = await selectSysDic(name);
//     if (res.code == 200) {
//       cache[name] = res.data;
//       // 如果是获取单个字典的值
//       if (isSingle) {
//         const singleDicName = cache[name].find((item) => item.id == id);
//         return singleDicName;
//       }
//       return cache[name];
//     }
//   } catch (error) {
//     console.log("缓存字典数据接口调用出错:" + error);
//   }
// }

class Dictionary {
  constructor() {
    this.items = {};
  }

  // 根据id获取单个字典名称
  getNameById(name, id) {
    if (!this.items[name]) {
      return this.getValuesByName(name).then(() => {
        const dic = this.items[name].find((item) => item.id == id);
        return dic?.codeName || "";
      });
    } else {
      const dic = this.items[name].find((item) => item.id == id);
      return dic?.codeName || "";
    }
  }

  // 根据字典类型，获取所有的字典值
  async getValuesByName(name) {
    if (this.items[name]) {
      return this.items[name];
    }
    const res = await selectSysDic(name);
    if (res.code == 200) {
      this.items[name] = res.data;
      return this.items[name];
    }
    return [];
  }
}
const dictionary = new Dictionary();
export { dictionary };
